import styled from "styled-components";
export const SimplePaginationItemContainer = styled.input `
  ${({ theme, selected }) => `
  background: ${theme.colors.white};
  border: 1px solid ${selected ? theme.colors.black : theme.colors.grey10};
  border-radius: 0;
  font-size:${theme.fontTokens.font12[0]};
  font-weight: ${theme.fontWeights.regular};
  color: ${theme.colors.black};
  width: 4rem;
  margin: 0 0.25rem 0 0rem;
  padding-right: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-end;
  text-align: right;
  height: 2.5rem;
  -webkit-appearance: none;

  @media ${theme.device.touch} {
    height: 2.75rem;
  }

  @media (hover: hover) {
    :hover {
      cursor: pointer;
      background: ${theme.colors.offWhite};
      border: 1px solid ${theme.colors.grey14};
    }
  }

  :active {
    ${theme.global.disableTapHighlight}
    background-color: ${theme.colors.grey05};
    border: 1px solid ${theme.colors.black};
   
  }

  :disabled {
    background: rgb(${theme.colors.transparentBlack}, 0.04);
    border: ${theme.colors.black};
    color: rgb(${theme.colors.transparentBlack}, 0.04);
  }`}

  ${({ isTabFocused, theme }) => isTabFocused
    ? `
      :focus {background: ${theme.colors.white};
      border: 1px solid  ${theme.colors.primaryLight};
      outline: 1px solid ${theme.colors.primaryLight};}
    `
    : `

    `}
    ${({ isMouseFocused, theme, selected }) => isMouseFocused
    ? `background:  ${theme.colors.grey05};
      outline: none;
    `
    : `
      background: ${theme.colors.white};
      border: 1px solid ${selected ? theme.colors.black : theme.colors.grey10};
       outline: none;
    `}
`;
